import PropTypes from 'prop-types';
import React from 'react'
import Link from "../Link/Link"
import NavBarList from './NavBarList'

function NavbarMegaMenu({ locationPathName, menu, onHandleClick }) {

  const menus = menu.map(menuItem =>
    <NavBarList
      key={menuItem.id}
      locationPathName={locationPathName}
      menuName={menuItem.menuName}
      menu={menuItem.menu}
      onHandleClick={onHandleClick}
      wrap={menuItem.wrap}
    />
  );

  return (
    <div className="navbar-dropdown-megamenu">
      <div className="megamenu-description">
        <p>
          Fueled by research experts, Beyond looks past the current reality to a different future. It provides a deeper understanding of today’s issues and offers solutions to help shape a better world.
          {' '}
          <Link to="/about/">About Beyond</Link>
        </p>
      </div>
      {menus}
    </div>
  )
}

NavbarMegaMenu.propTypes = {
  locationPathName: PropTypes.string,
  menu: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      menuName: PropTypes.string,
      menu: PropTypes.arrayOf(
        PropTypes.objectOf(PropTypes.string)
      ),
      wrap: PropTypes.bool
    })
  ),
  onHandleClick: PropTypes.func
};

NavbarMegaMenu.defaultProps = {
  locationPathName: '',
  menu: [],
  onHandleClick: () => { }
};


export default NavbarMegaMenu
